import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
    Radio,
    RadioGroup,
    FormControlLabel,
    LinearProgress,
    Typography,
} from '@material-ui/core';

import * as organizationConstants from '../../constants/organizations';
import * as bucketSelectors from '../../selectors/bucketSelectors';
import Search from './Search';

class SearchAndPickBucket extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filterName: '',
            pickedBucketId: '',
            page: 0,
        };

        props.searchBuckets({
            organizationId: props.organization.id,
            resetList: true,
        });
    }

    onBucketSearch = filterName => {
        this.props.searchBuckets({
            organizationId: this.props.organization.id,
            filterName,
            resetList: true,
        });

        this.setState({ filterName, page: 0 });
    };

    onLoadMore = () => {
        const { filterName, page } = this.state;

        this.props.searchBuckets({
            organizationId: this.props.organization.id,
            filterName,
            page: page + 1,
        });

        this.setState({ page: page + 1 });
    };

    onPickBucket = e => {
        const pickedBucketId = e.target.value;
        this.setState({ pickedBucketId });

        const bucket = this.props.buckets.find(
            b => b.id === parseInt(pickedBucketId, 10),
        );
        this.props.onChange(bucket);
    };

    render() {
        const {
            classes,
            organization,
            currentBucket,
            buckets,
            areThereMorePages,
        } = this.props;
        const { filterName, pickedBucketId } = this.state;

        if (!organization || !buckets) {
            return null;
        }

        const bucketList = buckets.map(bucket => (
            <FormControlLabel
                key={'radio-' + bucket.id}
                value={'' + bucket.id}
                control={<Radio />}
                label={bucket.name}
                disabled={currentBucket.id === bucket.id}
            />
        ));

        return (
            <div className={classes.container}>
                <Search
                    value={filterName}
                    onChange={this.onBucketSearch}
                    placeholder="Search projects..."
                />
                <div id="scroller" className={classes.scroller}>
                    <InfiniteScroll
                        className={classes.infiniteScroll}
                        dataLength={buckets.length}
                        pageStart={0}
                        next={this.onLoadMore}
                        hasMore={areThereMorePages}
                        userWindow={false}
                        loader={<LinearProgress />}
                        scrollableTarget="scroller"
                    >
                        <RadioGroup
                            className={classes.list}
                            value={pickedBucketId}
                            onChange={this.onPickBucket}
                        >
                            {bucketList}
                        </RadioGroup>
                    </InfiniteScroll>
                    {bucketList.length === 0 && (
                        <Typography variant="body1">
                            No buckets found.
                        </Typography>
                    )}
                </div>
            </div>
        );
    }
}

SearchAndPickBucket.propTypes = {
    organization: PropTypes.object.isRequired,
    onlyAdminBuckets: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

const style = ({ palette }) => ({
    scroller: {
        height: '300px',
        overflow: 'auto',
    },
    list: {
        display: 'flex',
        padding: '6px',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        '& label': {
            margin: 0,
            '&:hover': {
                backgroundColor: palette.background.gray1Color,
            },
        },
    },
});

const mapStateToProps = (state, ownProps) => ({
    currentBucket: bucketSelectors.getBucket(state),
    buckets: bucketSelectors.getBuckets(state, ownProps.organization.id),
    areThereMorePages: bucketSelectors.areThereMorePages(
        state,
        ownProps.organization.id,
    ),
});

const mapDispatchToProps = dispatch => ({
    searchBuckets: ({ organizationId, filterName, page, resetList }) => {
        dispatch({
            type: organizationConstants.FETCH_ORGANIZATION_BUCKETS_REQUEST,
            payload: {
                organizationId,
                page,
                filterName,
                resetList,
            },
        });
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectSheet(style)(SearchAndPickBucket));



// WEBPACK FOOTER //
// ./src/components/search/SearchAndPickBucket.js